export const BACKEND_BASE_URL = process.env.VUE_APP_SVC_BACKEND_BASE_URL as string;

export interface IPageRequest {
  page: number;
  size: number;
  sort?: string;
}

export interface IPageResponse<T> {
  content: T[];
  pageable: IPageableResponse;
  totalElements: number;
  totalPages: number;
  last: boolean;
  size: number;
  number: number;
  sort: ISortResponse;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}

export interface IPageableResponse {
  sort: ISortResponse;
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

export interface ISortResponse {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface IResponse {
  status: number;
  errorCode?: string;
}

export interface IResponseError {
  timestamp: string;
  status: number;
  code?: string;
  error: string;
  message: string;
  path: string;
  errors?: unknown[];
}

export interface IGenericResponse<T> {
  status: number;
  message: string;
  details: T;
}

export enum EDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface IPaged {
  direction?: EDirection;
  orderBy?: string;
  page?: number;
  size?: number;
}
